import { STATIC_URL } from './env';

export {
  COMMON_POINTS_DEDUCT,
  COMMON_POINTS_GENERATE,
  COMMON_POINTS_REGENERATE,
  USER_POINTS_STATUS_ERROR,
  USER_POINTS_STATUS_WARNING,
} from './credit';

export const DEFAULT_PATH_AFTER_LOGIN = '/workspace';

/** 用户头像URL前缀 */
export const AVATAR_URL_PREFIX = `${STATIC_URL}/assets/onepage/user/image/`;

/** 默认头像文件名标识 */
export const DEFAULT_AVATAR_FILENAME = '-';

/** 联系邮箱 */
export const WEGIC_CONTACT_EMAIL = 'contact@wegic.ai';

/** 帮助中心链接 */
export const WEGIC_HELP_CENTER_URL = 'https://help.wegic.ai';

/** 官网链接 */
export const WEGIC_HOMEPAGE_URL = window.location.origin || 'https://wegic.ai';

/** Facebook 链接 */
export const WEGIC_FACEBOOK_URL = 'https://www.facebook.com/groups/758678533887120';

/** 联盟链接 */
export const WEGIC_AFFILIATE_URL = 'https://wegic.ai/affiliates';

/** 老带新政策页面链接 */
export const WEGIC_REFERRAL_POLICY_URL = 'https://privacy.wegic.ai/wegic-referral-terms';
